<template>
    <v-container  >
      <v-card pa-2 >
        <div align="left" class="pa-2">
           Last updated: March 23, 2020
      <h1>Privacy & Security</h1>
        Your privacy is important to us. Read below to find out what that means.

        <br><br>
      <h2>Your Pictures, Text and Content</h2>
      <br>
      <h3>Offline Mode</h3>
        You can use this app in offline mode by not signing in.  In offline mode, we never see your data.
        It is stored on your local computer or phone in the roughly 5MB of space that your browser gives each site
        in the local cache.
        Only people with access to your computer can see this data in offline mode.
        Note that some browsers use online APIs to implement speech-to-text and text-to-speech services,
        so you may be sharing data with 3rd parties while in offline mode.
        <br><br>
        Clearing your browser cache will delete all of this data, but you can also delete it by clicking below:<br>
        <v-btn @click="onClearCash">
          <v-icon>delete</v-icon>
          Delete Local Data
          <v-icon>delete</v-icon>
        </v-btn>
        <br><br>
        <br>

      <h3>Signing in and Publishing Content</h3>
        If you want to show your content to someone on a different computer or device, you will need to publish it to the cloud.
        We use Google Firebase to enable sign-in and store your published content in the cloud.
        You can read more about their privacy policies <a href="https://firebase.google.com/support/privacy">here</a>.
        You need to sign in to publish content.
        You can delete your published content whenever you want.
        Hosted content is available for anyone to see that has a link to it, so only share the link securely and to people you trust.
       <br><br>

      <h2>Speech Recognition</h2>
        When we can, we use the <a href="https://wicg.github.io/speech-api/">HTML5 Speech Recognition API</a> to let you talk to your pictures with your voice.
        Google Chrome is the only browser that supports this API, so if this feature is important to you, use Chrome (on a desktop browser for best results, as Chrome on iOS will not work).
        There are robust privacy protections specified in the API, and you must grant permission for it to be enabled for this site.  We can't hear what you say, but Google can.
        Our app gets a transcription of what you say, and we only use this make it feel like you are talking to your pictures.  We try to make it very clear when we have enabled
        recording by displaying a live transcript of what google hears you say.
        <br><br>
        <h2>Updates To Privacy Policy</h2>
        We may update this privacy policy by posting a new version and updating the date at the top.
        </div>
      </v-card>
    </v-container>
</template>
<script>
export default {
  props: {},
  data () {
    return {
    }
  },
  mounted: function () {
  },
  methods: {
    onClearCash: function () {
      localStorage.clear()
      this.$router.go()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Privacy.vue